<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form"
    @submit.prevent="onSubmit"
  >
    <v-row class="mt-3">
      <v-col cols="12" lg="3" md="3" sm="12">
        <v-text-field
          v-model="form.inscricaoEstadual"
          placeholder="Digite a inscrição Estadual"
          label="Inscrição estadual"
          dense
          outlined
        />
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12">
        <AtuationAreaSelect
          v-model="form.listIdAreaAtuacao"
          placeholder="Digite Área de Atuação"
          label="Área Atuação *"
        />
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12">
        <ServiceSelect
          v-model="form.listIdServico"
          placeholder="Digite Serviço"
          label="Serviço *"
        />
      </v-col>
      <v-col v-if="isFretamento()" cols="12" lg="3" md="3" sm="12">
        <v-radio-group v-model="form.turismo" class="mt-0" row label="Turismo?">
          <v-radio label="Sim" :value="true" />
          <v-radio label="Não" :value="false" />
        </v-radio-group>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-text-field
          v-model="form.razaoSocial"
          placeholder="Digite a razão social"
          label="Razão Social *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-text-field
          v-model="form.nomeFantasia"
          placeholder="Digite a nome fantasia"
          label="Nome Fantasia *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <v-text-field
          v-model="formattedCnpj"
          placeholder="Digite o CNPJ"
          label="CNPJ *"
          :rules="[rules.required, rules.cnpj]"
          maxlength="18"
          dense
          outlined
        />
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12">
        <ZipCodeField
          v-model="form.endereco.cep"
          label="CEP*"
          placeholder="Digite o Cep"
        />
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12">
        <v-text-field
          v-model="form.endereco.logradouro"
          placeholder="Ex:. Av. Deputado Paulino Rocha"
          label="Logradouro *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12">
        <v-text-field
          v-model="form.endereco.numero"
          placeholder="Digite o número logradouro"
          label="Número *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12">
        <v-text-field
          v-model="form.endereco.complemento"
          placeholder="Digite o complemento do logradouro"
          label="Complemento"
          dense
          outlined
        />
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <StateSelect
          v-model="form.endereco.estado"
          placeholder="Digite o estado"
          label="Estado *"
        />
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <CitySelect
          v-model="form.endereco.cidade"
          placeholder="Digite a cidade"
          label="Cidade *"
          :disabled="form.endereco.estado && !form.endereco.estado?.id"
        />
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="12">
        <DistrictSelect
          v-model="form.endereco.bairro"
          placeholder="Digite o bairro"
          label="Bairro *"
          :city-id="form.endereco.cidade && form.endereco.cidade?.id"
          :disabled="!form.endereco.cidade?.id"
        />
      </v-col>
    </v-row>

    <h3 class="title">Contatos</h3>

    <v-divider class="mb-4" />

    <!-- <ContactForm v-model="form.contatoTransportadoraDto" /> -->
    <ContactList v-model="form.contatoTransportadoraDto" />

    <v-row>
      <v-col cols="12" lg="12" md="12" sm="12">
        <v-text-field
          v-model="form.verificacao.codigo"
          placeholder="Digite código recebido no email"
          label="Código de verificação *"
          :rules="[rules.required]"
          dense
          outlined
        />
      </v-col>
    </v-row>

    <v-divider />

    <v-card-actions class="mr-0 ml-0 pt-0 pb-0 pr-0">
      <v-spacer />
      <v-btn depressed type="submit" color="primary" class="mt-3">
        Continuar
      </v-btn>
    </v-card-actions>
    <!-- <pre>{{ form }}</pre> -->

    <section v-if="formState.isLoading" class="loading">
      <v-progress-circular indeterminate color="primary" />
      <span>Enviando informações ...</span>
    </section>
  </v-form>
</template>

<script>
import ZipCodeField from "./ZipCodeField";
import StateSelect from "./StateSelect";
import CitySelect from "./CitySelect";
import DistrictSelect from "./DistrictSelect";
import AtuationAreaSelect from "./AtuationAreaSelect";
import ServiceSelect from "./ServiceSelect";
import ContactForm from "./ContactForm";
import ContactList from "./ContactList";

// Vuex Store - Sit Pedidos (mapping actions and states)
import { mapState, mapActions } from "vuex";
import pedidoService from "@/services/sit-pedidos/pedido.service";
import {
  formatAlphanumericCNPJ,
  validateAlphanumericCNPJ,
} from "@/helpers/cnpj-alphanumeric.validator";
const actions = mapActions("sitPedidos", [
  "setFormPedido",
  "setFormIsLoading",
  "setFormStep",
]);
const state = mapState("sitPedidos", { formState: "form" });

const initialFormState = {
  verificacao: {
    codigo: null,
  },
  endereco: {
    cep: null,
    complemento: null,
    logradouro: null,
    numero: null,
    bairro: { id: null },
    cidade: { id: null },
    estado: { id: null },
  },
  nomeFantasia: null,
  razaoSocial: null,
  cnpj: null,
  listIdAreaAtuacao: null,
  listIdServico: null,
  inscricaoEstadual: null,
  turismo: false,
  contatoTransportadoraDto: [],
};

export default {
  name: "ShippingCompanyForm",

  components: {
    ZipCodeField,
    StateSelect,
    CitySelect,
    DistrictSelect,
    AtuationAreaSelect,
    ServiceSelect,
    // ContactForm,
    ContactList,
  },

  data: () => ({
    form: { ...initialFormState },

    rules: {
      required: (value) => {
        if (!value) return true;

        return (
          !!value.replaceAll(/\s/g, "") || "Esse campo deve ser preenchido"
        );
      },
      cnpj: (value) =>
        !value || validateAlphanumericCNPJ(value) || "CNPJ inválido",
    },
  }),

  computed: {
    ...state,

    formattedCnpj: {
      get() {
        return this.form.cnpj;
      },
      set(value) {
        this.form.cnpj = formatAlphanumericCNPJ(value);
      },
    },
  },

  watch: {
    "form.endereco.cidade.id"(newValue) {
      this.form.endereco = { ...this.form.endereco, bairro: { id: null } };
    },
    "form.listIdServico"(newValue) {
      this.form.turismo = false;
    },
    "formState.contact"(newValue) {
      this.form.contatoTransportadoraDto = [newValue];
    },
  },

  methods: {
    ...actions,

    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.setFormIsLoading(true);

        const form = this.formData();

        const tipoServicos = [[
    {
        "id": 3,
        "descricao": "Fretamento",
        "disable": false
    }
]]
        console.log(this.form.listIdServico)
        pedidoService.createShippingCompany(form).subscribe(
          (res) => {
            res.tipoServico = tipoServicos;
            this.setFormIsLoading(false);
            this.setFormPedido(res);
            this.setFormStep(3);
            this._clearForm();
          },
          (err) => {
            this.setFormIsLoading(false);
          }
        );
      }
    },

    formData() {
      const {
        verificacao,
        nomeFantasia,
        razaoSocial,
        cnpj,
        listIdAreaAtuacao,
        listIdServico,
        inscricaoEstadual,
        turismo,
        contatoTransportadoraDto,
        endereco: {
          cep,
          complemento,
          logradouro,
          numero,
          bairro,
          cidade,
          estado,
        },
      } = this.form;

      const areaAtuacaoIds = listIdAreaAtuacao.map((a) => a?.id);
      const serviceIds = listIdServico.map((a) => a?.id);

      return {
        verificacao,
        nomeFantasia,
        razaoSocial,
        cnpj,
        listIdAreaAtuacao: areaAtuacaoIds,
        listIdServico: serviceIds,
        cep,
        complemento,
        logradouro,
        numero,
        bairro,
        municipio: cidade,
        uf: estado,
        inscricaoEstadual,
        turismo,
        contatoTransportadoraDto,
      };
    },

    isFretamento() {
      if (!this.form.listIdServico) {
        return false;
      }

      return this.form.listIdServico.some(
        (ls) => ls.descricao.toLowerCase() === "Fretamento".toLowerCase()
      );
    },

    _clearForm() {
      this.form = { ...initialFormState };
      this.$refs.form.reset();
    },
    // paraTestesDoFormulario() {
    //   const testes = {
    //     dataCriacao: "2023-06-29",
    //     id: 8615,
    //     status: "AGUARDANDO_DOCUMENTACAO",
    //     tipoPedido: "CADASTRO_TRANSPORTADORA",
    //     tipoServico: [
    //       {
    //         id: 1,
    //         descricao: "fretamento",
    //         disable: false,
    //       },
    //     ],
    //   };
    //   this.setFormPedido(testes);
    // },
  },
  mounted() {
    // this.paraTestesDoFormulario();
  },
};
</script>
